import { observer } from "mobx-react";
import { useStore } from "../../../../storeManager/stores";
import GenerateKeyModal from "./GenerateKeyModal";

const ApiKeyModals = () => {
  const { apiKeyModal } = useStore().settingsStore;
  return (
    <div className="w-full h-auto">{apiKeyModal && <GenerateKeyModal />}</div>
  );
};

export default observer(ApiKeyModals);
